import React from 'react';
import { bool, func } from 'prop-types';
import { IoIosArrowDown, IoIosArrowForward } from 'react-icons/io';

const NavigationMobileMenuItemIcons = ({ expanded, toggleExpanded }) => {
    return expanded ? (
        <IoIosArrowDown
            className={'cursor-pointer'}
            onClick={toggleExpanded} />
    ) : (
        <IoIosArrowForward
            className={'cursor-pointer'}
            onClick={toggleExpanded} />
    );
};
const NavigationMobileMenuItemIconsProps = {
    expanded: bool,
    toggleExpanded: func,
};
NavigationMobileMenuItemIcons.propTypes = NavigationMobileMenuItemIconsProps;
export default NavigationMobileMenuItemIcons;